import getAPIResponse from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';
import { GetImprovementProposalList } from '../../ImprovementProposal/Domain/Responses/GetImprovementProposalList';

export async function getImprovementProposalList(params = {}) {
  const response = await getAPIResponse('/v1/improvement-proposal', params);
  if (response === null) return null;
  try {
    return GetImprovementProposalList.createFromResponseData(response);
  } catch (e) {
    return null;
  }
}
